import { Component, Input } from '@angular/core'
import { DatePipe } from '@angular/common'
import { TransactionDetails } from '../../models'

@Component({
    selector: 'ach-noc-info',
    standalone: true,
    imports: [DatePipe],
    templateUrl: './noc-info.component.html',
    styleUrl: './noc-info.component.scss',
})
export class NocInfoComponent {
    @Input({ required: true }) details!: TransactionDetails
}
